<template>
    <Path>
        <template v-slot:path>
            <li>
                <router-link :to="{ name: 'dashboard' }">الصفحة الرئيسية</router-link>
            </li>
            <li> <span class="divider"> / </span><a href="#services"
                    @click="$router.push({ name: 'dashboard' })">الخدمات
                </a> </li>
            <li> <span class="divider"> / </span>
                <router-link :to="{ name: 'electronicservices' }">الخدمات الالكترونية</router-link>
            </li>
            <li> <span class="divider"> / </span><a href="#">استخراج قيد عائلى</a> </li>
        </template>
    </Path>

    <section v-if="!isReview" id="content">
        <div class="py-5 ">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-2">
                        <h2 class="blueFont ">الطلب {{ docRequests.totalRequests }} / {{ docRequests.requestNo }} قيد
                            عائلى
                        </h2>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-6">
                        <label for="basic-url" class="form-label">الاسم رباعي لصاحب القيد</label>
                        <div class="input-group mb-3">
                            <div class="row g-3">
                                <div class="col-6 col-sm">
                                    <input v-model="form.firstName" type="text" class="form-control" id="basic-url1"
                                        aria-describedby="basic-addon3" @blur="v$.form.firstName.$touch()">
                                    <p class="data--required" v-for="error of v$.form.firstName.$errors"
                                        :key="error.$uid">
                                        {{ error.$message }}
                                    </p>
                                </div>
                                <div class="col-6 col-sm">
                                    <input v-model="form.secondName" type="text" class="form-control" id="basic-url2"
                                        aria-describedby="basic-addon3" @blur="v$.form.secondName.$touch()">
                                    <p class="data--required" v-for="error of v$.form.secondName.$errors"
                                        :key="error.$uid">
                                        {{ error.$message }}
                                    </p>
                                </div>
                                <div class="col-6 col-sm">
                                    <input v-model="form.thirdName" type="text" class="form-control" id="basic-url3"
                                        aria-describedby="basic-addon3" @blur="v$.form.thirdName.$touch()">
                                    <p class="data--required" v-for="error of v$.form.thirdName.$errors"
                                        :key="error.$uid">
                                        {{ error.$message }}
                                    </p>
                                </div>
                                <div class="col-6 col-sm">
                                    <input v-model="form.fourthName" type="text" class="form-control" id="basic-ur4l"
                                        aria-describedby="basic-addon3" @blur="v$.form.fourthName.$touch()">
                                    <p class="data--required" v-for="error of v$.form.fourthName.$errors"
                                        :key="error.$uid">
                                        {{ error.$message }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label for="basic-url" class="form-label">الرقم القومى لصاحب القيد</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <input v-model="form.nid" type="text" class="form-control" id="basic-url1"
                                    aria-describedby="basic-addon3" @blur="v$.form.nid.$touch()">
                                <p class="data--required" v-for="error of v$.form.nid.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-6">
                        <label for="" class="form-label">اسم الام بالكامل لصاحب القيد</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <input v-model="form.motherName" type="text" class="form-control " id="basic-ur4l"
                                    aria-describedby="basic-addon3" @blur="v$.form.motherName.$touch()">
                                <p class="data--required" v-for="error of v$.form.motherName.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <label for="" class="form-label">الجهه المقدم إليها </label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <input v-model="form.destination" type="text" class="form-control " id="basic-ur4l"
                                    aria-describedby="basic-addon3" @blur="v$.form.destination.$touch()">
                                <p class="data--required" v-for="error of v$.form.destination.$errors"
                                    :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-6">
                        <label for="" class="form-label">النوع</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <select v-model="gender" class="form-select" id="basic-url1"
                                    aria-describedby="basic-addon3" @blur="v$.gender.$touch()">
                                    <option v-for="gender in gender_lookups" :key="gender.Id" :value="gender.Code">
                                        {{ gender.Name }}</option>
                                </select>
                                <p class="data--required" v-for="error of v$.gender.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>

                        </div>
                    </div>

                    <div class="col-md-6">
                        <label for="" class="form-label">صلة القرابة</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <select v-model="form.relationCode" class="form-select" id="basic-url1"
                                    aria-describedby="basic-addon3" @blur="v$.form.relationCode.$touch()">
                                    <option v-for="relation in relation_lookups" :key="relation.Id"
                                        :value="relation.Code">
                                        {{ relation.Name }}</option>
                                </select>
                                <p class="data--required" v-for="error of v$.form.relationCode.$errors"
                                    :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-6 col-md-2">
                        <label for="" class="form-label mb-3">عدد النسخ</label>
                    </div>
                    <div class="col-6 col-md-4  mb-3 counter_input">
                        <button @click="copies++" type="button" class="pa-0  ma-0  icon-btn"><i
                                class="bi bi-plus-circle"></i></button>
                        <input v-model="copies" type="text" class="form-control  text-center" aria-label="">
                        <button @click="copies--" type="button" class="pa-0 ma-0 icon-btn"><i
                                class="bi bi-dash-circle"></i></button>
                    </div>
                    <div class="col-6 col-md-3 mb-3">
                        <label for="" class="form-label">اجمالى سعر الخدمة</label>
                    </div>
                    <div class="col-6 col-md-3 mb-3">
                        <input v-model="totalPrice" type="text" readonly="readonly" class="form-control text-center"
                            aria-label="">
                    </div>
                </div>

                <div class="row">
                    <div class="row my-5 justify-content-center">

                        <div :hidden="docRequests.requestNo === 1" class="col-6 col-sm-2 mx-5 mb-3">
                            <div class="d-flex justify-content-center">
                                <button @click="previousDoc" type="button"
                                    class="btn1 btn-light mx-3 align-self-center">
                                    القيد السابق
                                </button>
                            </div>
                        </div>
                        <div :hidden="docRequests.totalRequests === docRequests.requestNo" class="col-6 col-sm-2 mx-5 mb-3 ">
                            <div class="d-flex justify-content-center">
                                <button @click="nextDoc" type="button" class="btn1 btn-light mx-3 align-self-center">
                                    القيد التالى
                                </button>
                            </div>
                        </div>
                        <div :hidden="docRequests.totalRequests !== docRequests.requestNo" class="col-6 col-sm-2 mx-5 mb-3">
                            <div class="d-flex justify-content-center">
                                <button @click="addFamilyRecord" type="button"
                                    class="btn1 btn-light mx-3 align-self-center">
                                    إضافة قيد
                                </button>
                            </div>
                        </div>

                        <div :hidden="docRequests.requestNo === 1" class="col-6 col-sm-2 mx-5 mb-3">
                            <div class="d-flex justify-content-center">
                                <button @click="deleteDocument" type="button"
                                    class="btn1 btn-light mx-3 align-self-center">
                                    حذف قيد
                                </button>
                            </div>
                        </div>

                        <div class="col-6 col-sm-2 mx-5 mb-3 ">
                            <div class="d-flex justify-content-center">
                                <button @click="review_request" type="button"
                                    class="btn1 btn-light mx-3 align-self-center">
                                    مراجعة الطلب
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <Review v-if="isReview" @close="toggle_isReview()" :serviceprice="price" :DocCode="FamilyRecordCode"
        DocType="قيد عائلى " :DocData="DocData" :isNid="false" />

</template>


<script>
import validations from "@/shared/validations.js";
import sharedMethods from "@/shared/sharedMethods";
import { mapActions, mapGetters } from "vuex";
import useVuelidate from "@vuelidate/core";
import Path from "@/components/Path.vue";
import Review from "@/components/Review.vue";
import { ref } from 'vue';
import sharedData from '@/shared/sharedData';
import { debugLog } from "@/plugins/debug";

export default {
    ...sharedMethods,
    name: 'PersonalRecordView',
    components: { Path, Review },
    data() {
        return {

            v$: useVuelidate(),

            valid: false,
            count: 0,
            docsCount: 1,

            price: 0,
            totalPrice: 0,

            responseMessage: '',
            responseCode: 200,

            // # document requests
            docRequests: {
                requestNo: 1,
                totalRequests: 1
            },

            gender_lookups: [],
            relation_lookups: [],
            gender: '',
            copies: 1,
            FamilyRecordCode: sharedData.DocumentsCode.FamilyRecordCode,

            form: {
                firstName: '',
                secondName: '',
                thirdName: '',
                fourthName: '',
                nid: '',
                motherName: '',
                destination: '',
                relationCode: '',
            },
        }
    },
    setup() {
        const isReview = ref(false);
        const toggle_isReview = () => {
            isReview.value = !isReview.value;
        }
        return { isReview, toggle_isReview }
    },

    // validations
    validations() {
        return validations.FamilyRecord
    },

    created() {
        // reset after refersh or reloading page
        this.resetDocs();  // store action for resetting number of requests in store to 0
        this.docRequests.requestNo = 1;
        
        setTimeout(() => {
            sharedMethods.get_servicePrice("familyRecordPrice").then(res => { this.price = res; this.totalPrice = res; });
            sharedMethods.get_genders().then(res => { this.gender_lookups = res; });
        }, 200);
        
        window.scrollTo({ top: 0, behavior: "smooth" });
        //   this.AutoFill();
    },
    watch: {
        gender(newGender) {
            if (newGender) {
                sharedMethods.get_relations(this.FamilyRecordCode, this.gender).then(res => { this.relation_lookups = res; });
            }
        },

        copies(newCopy) {
            this.totalPrice = this.price * newCopy;
            if (newCopy > 5) {
                this.copies = 5;
            }
            if (newCopy <= 1) {
                this.copies = 1;
            }
        }
    },

    computed: {
        ...mapGetters({ familyRecords: "StateDocs", options: "StateOptions", contactInfo: "StateContact" }),

        DocData() {
            return {
                "familyRecords": Object.values(this.familyRecords),
                ...this.contactInfo
            }
        }
    },

    methods: {
        ...mapActions(["saveDocs", "resetDocs", "deleteDoc"]),

        async review_request() {
            this.v$.$validate();
            if (!this.v$.$error) {
                this.saveDocument(); // save form data first in the store                      
                await sharedMethods.PreviewDoc(this.DocData, this.options).then(res => { this.responseCode = res.responseCode; this.responseMessage = res.responseMessage; });
                if (this.responseCode === 200) {

                    debugLog('Docs:', Object.values(this.familyRecords));
                    this.isReview = true;
                } else {
                    this.$alerts.toast.error(this.responseMessage);
                }

            } else {
                this.$alerts.toast.error('هناك خطأ فى البيانات المدخلة');
            }
        },

        // add new family record document
        async addFamilyRecord() {
            this.v$.$validate();
            if (!this.v$.$error) {
                this.saveDocument(); // save form data first in the store
                await sharedMethods.PreviewDoc(this.DocData, this.options).then(res => { this.responseCode = res.responseCode; this.responseMessage = res.responseMessage; });
                if (this.responseCode === 200) {
                    this.docRequests.totalRequests++;
                    this.docRequests.requestNo++;
                    this.docsCount++;
                    this.reset();
                } else {
                    this.$alerts.toast.error(this.responseMessage);
                }
            } else {
                this.$alerts.toast.error('هناك خطأ فى البيانات المدخلة');
            }
        },

        // go to previous document
        async previousDoc() {
            this.v$.$validate();
            if (!this.v$.$error) {
                this.saveDocument(); // save form data first in the store
                await sharedMethods.PreviewDoc(this.DocData, this.options).then(res => { this.responseCode = res.responseCode; this.responseMessage = res.responseMessage; });
                if (this.responseCode === 200) {
                    this.reset();
                    if (this.docRequests.requestNo > 1) {
                        this.docRequests.requestNo--;
                        this.docsCount--;
                    }

                    this.fillData();
                } else {
                    this.$alerts.toast.error(this.responseMessage);
                }
            } else {
                this.$alerts.toast.error('هناك خطأ فى البيانات المدخلة');
            }
        },

        // go to next document
        async nextDoc() {
            this.v$.$validate();
            if (!this.v$.$error) {
                this.saveDocument(); // save form data first in the store
                await sharedMethods.PreviewDoc(this.DocData, this.options).then(res => { this.responseCode = res.responseCode; this.responseMessage = res.responseMessage; });
                if (this.responseCode === 200) {
                    this.reset();
                    if (this.docRequests.requestNo < this.docRequests.totalRequests) {
                        this.docRequests.requestNo++;
                        this.docsCount++;
                    }
                    this.fillData();
                } else {
                    this.$alerts.toast.error(this.responseMessage);
                }
            } else {
                this.$alerts.toast.error('هناك خطأ فى البيانات المدخلة');
            }
        },

        // Delete document
        deleteDocument() {

            if (this.docRequests.requestNo > 1) {
                this.deleteDoc(this.docRequests.requestNo);
                this.docRequests.totalRequests--;
                this.docRequests.requestNo--;
                this.docsCount--;
            }

            this.fillData();
        },

        //auto fill for testing
        AutoFill() {
            this.form.firstName = "تسنيم";
            this.form.secondName = "سمير";
            this.form.thirdName = "محمد";
            this.form.fourthName = "شحاتة";
            this.form.motherName = "ماما";
            this.form.nid = "29709011235741";
            this.copies = 1;

        },

        // fill data in the form in case of already existing docs
        fillData() {

            if (this.familyRecords[this.docRequests.requestNo]) {

                let fullname = (this.familyRecords[this.docRequests.requestNo]).name.fullName.split(' ')

                this.form.firstName = fullname[0];
                this.form.secondName = fullname[1];
                this.form.thirdName = fullname[2];
                this.form.fourthName = fullname[3];
                this.form.motherName = (this.familyRecords[this.docRequests.requestNo]).motherFullName;
                this.form.nid = (this.familyRecords[this.docRequests.requestNo]).nid.nationalIdenNumber;
                this.form.relationCode = (this.familyRecords[this.docRequests.requestNo]).relationCode;
                this.form.destination = (this.familyRecords[this.docRequests.requestNo]).applicantEntity;
                this.copies = (this.familyRecords[this.docRequests.requestNo]).numberOfCopies;
                this.gender = (this.familyRecords[this.docRequests.requestNo]).genderCode;

            }

        },

        // assign data to variables and save it to the store
        saveDocument() {
            let docData = {
                "numberOfCopies": parseInt(this.copies),
                "name": { "fullName": this.form.firstName + ' ' + this.form.secondName + ' ' + this.form.thirdName + ' ' + this.form.fourthName },
                "applicantEntity": this.form.destination,
                "motherFullName": this.form.motherName,
                "nid": { "nationalIdenNumber": this.form.nid },
                "relationCode": "SELF",
                "genderCode": this.gender,
            }
            let savedata = {
                "reqNo": this.docRequests.requestNo,
                "document": docData,
            }


            this.saveDocs(savedata);  // store action for saving requests

        },

        // empty form data to fill new one
        reset() {
            this.form = {};
            this.copies = 1;
            this.gender = '',
            this.checked = false;
            this.v$.$reset();
        }
    }
}
</script>